export default
{
    "status": 0,
    "data": null,
    "message": ""
}